import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/over", label: "Over ons" },
  { to: "/diensten", label: "Diensten" },
  { to: "/motoren", label: "Tweedehands" },
  { to: "/afspraak", label: "Afspraak" },
  { to: "/santini", label: "Santini" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#0A0A0B]/90 backdrop-blur-xl border-b border-[#2A2B31]" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-8 flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 shrink-0">
          <img src="/tt-logo.png" alt="TT Motorsports" className="h-11 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `font-display uppercase text-sm font-600 tracking-wide px-3 py-2 transition-colors ${
                  isActive ? "text-[#E10600]" : "text-[#F2F2F3] hover:text-[#E10600]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:0485741524"
            data-testid="nav-phone"
            className="hidden xl:flex items-center gap-2 text-sm font-mono-tt text-[#9A9CA3] hover:text-[#F2F2F3]"
          >
            <Phone size={15} className="text-[#E10600]" /> 0485 74 15 24
          </a>
          <Link
            to="/afspraak"
            data-testid="nav-cta-afspraak"
            className="bg-[#E10600] hover:bg-[#B80500] text-white font-display uppercase font-700 text-sm tracking-wide px-5 py-2.5 transition-colors"
          >
            Maak afspraak
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-[#F2F2F3] p-2"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-[#0A0A0B] border-t border-[#2A2B31] px-5 py-6">
          <nav className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={({ isActive }) =>
                  `font-display uppercase text-lg font-700 py-3 border-b border-[#1C1D22] ${
                    isActive ? "text-[#E10600]" : "text-[#F2F2F3]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/afspraak"
              className="mt-4 bg-[#E10600] text-white text-center font-display uppercase font-700 py-3"
            >
              Maak afspraak
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
